import { TableColumnsType } from "antd";
import moment from "moment";

import { insuranceTableType } from "../../models";
import { Key } from "react";

export const insuranceColumns = (searchInsurance: string) => {
  const columns: TableColumnsType<insuranceTableType> = [
    {
      title: "Osiguravajuće društvo",
      dataIndex: "name",
      filteredValue: [searchInsurance],
      onFilter: (value: boolean | Key, record: insuranceTableType) => {
        return record?.name
          ?.toLowerCase()
          .includes(searchInsurance.toLowerCase());
      },
    },
    {
      title: "Kontakt osoba",
      dataIndex: "contactPerson",
      responsive: ["sm"],
    },
    {
      title: "Datum",
      dataIndex: "createdAt",
      width: 190,
      responsive: ["lg"],
      sorter: (a, b) => moment(a.createdAt).diff(moment(b.createdAt)),
    },
  ];

  return columns;
};
